import {Route} from '@angular/router';
import {AuthGuard} from "../../shared/auth/auth.guard";
import {ShelterOverviewComponent} from "./shelter-overview/shelter-overview.component";

export const AnimalShelterRoutes: Route[] = [
  {
    path: 'animal-shelters',
    component: ShelterOverviewComponent,
    canActivate: [AuthGuard]
  }
];

